/**
 * Font Size pattern
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { cssLengthUnits } from "./cssUnits";

// eslint-disable-next-line max-len
export const fontSizePattern = `^((([0-9]+)(\\.[0-9]+)?|\\.[0-9]+)\\s*(${cssLengthUnits})|[A-Z_]+|inherit|xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large|larger|smaller)$`;
